import {Column} from "../../../atoms/Layout.tsx";
import AppBar from "../../../molecules/AppBar.tsx";
import SiteBasicInfoForm, {BasicSiteInformation} from "../../../templates/SiteBasicInfoForm.tsx";
import ContentArea from "../../../atoms/ContentArea.tsx";
import {Text} from "../../../style/typography.tsx";
import {createSite} from "../../../api/site.ts";
import {useNavigate} from "react-router";
import {useUserContext} from "../../../store/userContext.ts";

const CreateSitePage = () => {
    const navigate = useNavigate();
    const { user, setUser } = useUserContext();

    const onSubmit = async (info: BasicSiteInformation) => {
        if (!user) {
            return;
        }

        const site = await createSite({
            name: info.name,
            companyName: info.name,
            context: {
                postcode: info.postcode,
                operatingHours: info.operatingHours,
                purpose: info.purpose
            },
            type: info.type
        })

        setUser({...user, sites: [...user.sites, {siteId: site.id, siteName: site.name}]});
        navigate(`/u/dashboard/site/${site.id}/welcome`);
    };

    return <Column grow>
        <AppBar />
        <ContentArea>
            <Column gap="52">
                <Text role="heading" size="1" weight="medium">Tell us about your site</Text>
                <SiteBasicInfoForm onSubmit={onSubmit} />
            </Column>
        </ContentArea>
    </Column>
}

export default CreateSitePage;